import { Injectable, Inject, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { LocalStorageService } from '../local-storage/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private darkMode = false;
  private readonly storageService = inject(LocalStorageService);

  constructor(@Inject(DOCUMENT) private document: Document) { }

  toggleDarkMode(): void {
    this.darkMode = !this.darkMode;
    if (this.storageService.isAvailable) {
      this.document.body.classList.toggle('dark', this.darkMode);
    }
    this.storageService.setItem('darkMode', this.darkMode ? 'true' : 'false');
  }

  isDarkMode(): boolean {
    return this.darkMode;
  }

  loadUserPreference(): void {
    const savedTheme = this.storageService.getItem<string>('darkMode');
    this.darkMode = savedTheme === 'true';

    if (this.storageService.isAvailable) {
      this.document.body.classList.toggle('dark', this.darkMode);
    }
  }
}

// loadUserPreference(): void {
//   const savedTheme = localStorage.getItem('darkMode');
//   if (savedTheme) {
//     this.darkMode = savedTheme === 'true';
//   } else {
//     this.darkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
//   }
//   document.body.classList.toggle('dark-mode', this.darkMode);
// }

// loadUserPreference(): void {
//   // Only access localStorage in the browser
//   if (isPlatformBrowser(this.platformId)) {
//     const savedTheme = localStorage.getItem('darkMode');
//     this.darkMode = savedTheme === 'true';
//   } else {
//     this.darkMode = false; // Default for SSR
//   }
//   document.body.classList.toggle('dark-mode', this.darkMode);
// }
